import React from "react";
import PropTypes from "prop-types";

function ConnectBank({
  className,
  style,
  fill,
  innerFill,
  opacity,
  defaultWidth,
  defaultHeight
}) {
  return (
    <svg
      viewBox="0 0 114 114"
      width={style && style.width ? style.width : defaultWidth}
      height={style && style.width ? style.height : defaultHeight}
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill-rule="nonzero" fill="none">
        <path
          d="M112.476 20.8C53.758-1.594 57.89-.242 56.693.17-1.889 22.474 1.023 20.664 1.023 22.956v13.753c0 1.265 1.013 2.292 2.26 2.292h108.403c1.246 0 2.258-1.027 2.258-2.292 0-14.601.497-15.151-1.468-15.908zm-3.049 13.616H5.541v-9.88L57.484 4.778l51.943 19.758v9.88z"
          fill={fill}
        />
        <path
          d="M57.5 5L5 25v10h105V25L57.5 5zm0 25.36c-5.042 0-9.13-4.156-9.13-9.281 0-5.125 4.088-9.28 9.13-9.28 5.042 0 9.13 4.155 9.13 9.28 0 5.125-4.088 9.28-9.13 9.28z"
          fill={fill}
          opacity={opacity}
        />
        <path
          d="M107.717 35H7.283C6.023 35 5 36.045 5 37.333v9.334C5 47.955 6.023 49 7.283 49h100.434c1.26 0 2.283-1.045 2.283-2.333v-9.334c0-1.288-1.023-2.333-2.283-2.333zm-2.282 9.333H9.565v-4.666h95.87v4.666zM60.75 94H2.25C1.008 94 0 94.96 0 96.143v10.714C0 108.04 1.008 109 2.25 109h58.5c1.242 0 2.25-.96 2.25-2.143V96.143C63 94.96 61.992 94 60.75 94zM4.5 98.286h54v6.428h-54v-6.428z"
          fill={fill}
        />
        <path fill={fill} opacity={opacity} d="M5 99h55v6H5z" />
        <path
          d="M61.73 84H7.27C6.016 84 5 85.045 5 86.333v9.334C5 96.955 6.017 98 7.27 98h54.46c1.253 0 2.27-1.045 2.27-2.333v-9.334C64 85.045 62.983 84 61.73 84zM9.539 93.333v-4.666h49.924v4.666H9.538zM34.75 43h-22.5C11.008 43 10 44.044 10 45.33v4.66c.009 2.954 1.809 5.584 4.5 6.57 1.463.582 1.102.419 15.75.419 3.728 0 6.75-3.129 6.75-6.99v-4.66C37 44.045 35.992 43 34.75 43zm-2.25 6.99c0 1.286-1.008 2.33-2.25 2.33h-13.5c-1.242 0-2.25-1.044-2.25-2.33v-2.33h18v2.33z"
          fill={fill}
        />
        <path
          d="M32.5 75.44c-1.462-.582-1.102-.419-15.75-.419-3.728 0-6.75 3.129-6.75 6.99v4.66C10 87.955 11.008 89 12.25 89h22.5c1.242 0 2.25-1.044 2.25-2.33v-4.66c-.009-2.954-1.809-5.584-4.5-6.57zm-18 8.9v-2.33c0-1.286 1.008-2.33 2.25-2.33h13.5c1.242 0 2.25 1.044 2.25 2.33v2.33h-18z"
          fill={fill}
        />
        <path
          d="M29.75 52h-13.5A2.25 2.25 0 0014 54.25v22.5A2.25 2.25 0 0016.25 79h13.5A2.25 2.25 0 0032 76.75v-22.5A2.25 2.25 0 0029.75 52zM18.5 74.5v-18h9v18h-9zM101.75 43h-22.5C78.008 43 77 44.044 77 45.33v4.66c.009 2.954 1.809 5.584 4.5 6.57 1.463.582 1.103.419 15.75.419 3.728 0 6.75-3.129 6.75-6.99v-4.66c0-1.285-1.008-2.329-2.25-2.329zm-2.25 6.99c0 1.286-1.008 2.33-2.25 2.33h-13.5c-1.242 0-2.25-1.044-2.25-2.33v-2.33h18v2.33z"
          fill={fill}
        />
        <path
          d="M97.75 52h-13.5C83.008 52 82 53.034 82 54.308v25.384C82 80.966 83.008 82 84.25 82h13.5c1.242 0 2.25-1.034 2.25-2.308V54.308C100 53.034 98.992 52 97.75 52zM86.5 77.385v-20.77h9v20.77h-9z"
          fill={fill}
        />
        <path
          d="M81.929 80.25V78H65.893c-3.796 0-6.872 3.022-6.872 6.75h2.29c1.265 0 2.291 1.008 2.291 2.25v-2.25c0-1.242 1.027-2.25 2.291-2.25H84.22c-1.265 0-2.291-1.008-2.291-2.25zm0 0V78H65.893c-3.796 0-6.872 3.022-6.872 6.75h2.29c1.265 0 2.291 1.008 2.291 2.25v-2.25c0-1.242 1.027-2.25 2.291-2.25H84.22c-1.265 0-2.291-1.008-2.291-2.25zm0 0V78H65.893c-3.796 0-6.872 3.022-6.872 6.75h2.29c1.265 0 2.291 1.008 2.291 2.25v-2.25c0-1.242 1.027-2.25 2.291-2.25H84.22c-1.265 0-2.291-1.008-2.291-2.25zm0 0V78H65.893c-3.796 0-6.872 3.022-6.872 6.75h2.29c1.265 0 2.291 1.008 2.291 2.25v-2.25c0-1.242 1.027-2.25 2.291-2.25H84.22c-1.265 0-2.291-1.008-2.291-2.25zM107.128 78H65.893c-3.796 0-6.872 3.022-6.872 6.75 0 24.142-.16 23.265.412 24.75.969 2.691 3.555 4.491 6.46 4.5h41.235c3.795 0 6.872-3.022 6.872-6.75v-22.5c0-3.728-3.077-6.75-6.872-6.75zm2.29 29.25c0 1.242-1.026 2.25-2.29 2.25H65.893c-1.264 0-2.29-1.008-2.29-2.25v-22.5c0-1.242 1.026-2.25 2.29-2.25h41.235c1.264 0 2.29 1.008 2.29 2.25v22.5zm-27.49-27V78H65.894c-3.796 0-6.872 3.022-6.872 6.75h2.29c1.265 0 2.291 1.008 2.291 2.25v-2.25c0-1.242 1.027-2.25 2.291-2.25H84.22c-1.265 0-2.291-1.008-2.291-2.25zm0 0V78H65.894c-3.796 0-6.872 3.022-6.872 6.75h2.29c1.265 0 2.291 1.008 2.291 2.25v-2.25c0-1.242 1.027-2.25 2.291-2.25H84.22c-1.265 0-2.291-1.008-2.291-2.25zm0 0V78H65.894c-3.796 0-6.872 3.022-6.872 6.75h2.29c1.265 0 2.291 1.008 2.291 2.25v-2.25c0-1.242 1.027-2.25 2.291-2.25H84.22c-1.265 0-2.291-1.008-2.291-2.25z"
          fill={fill}
        />
        <path d="M86 87a9 9 0 100 18 9 9 0 000-18z" fill={innerFill} />
        <path
          d="M105 94.5a2.5 2.5 0 01-5 0 2.5 2.5 0 015 0zM73 94.5a2.5 2.5 0 01-5 0 2.5 2.5 0 015 0z"
          fill={innerFill}
          opacity=".96"
        />
        <path
          d="M77.455 50.25V48h-40.91v2.25c-.009 2.853-1.827 5.393-4.545 6.345v18.81c2.718.952 4.536 3.492 4.545 6.345V84h22.728c0-3.728 3.052-6.75 6.818-6.75H82V56.595c-2.718-.952-4.536-3.492-4.545-6.345zm-15.25 12.847l-2.932-2.925V75c0 1.242-1.018 2.25-2.273 2.25-1.255 0-2.273-1.008-2.273-2.25V60.172l-2.932 2.925a2.299 2.299 0 01-3.227 0 2.244 2.244 0 010-3.194c9.932-9.833 6.818-9.968 16.864 0 .89.882.89 2.313 0 3.194a2.299 2.299 0 01-3.227 0z"
          fill="#90EEDA"
          opacity=".5"
        />
      </g>
    </svg>
  );
}

ConnectBank.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  fill: PropTypes.string,
  innerFill: PropTypes.string,
  opacity: PropTypes.number
};

ConnectBank.defaultProps = {
  className: undefined,
  defaultHeight: 114,
  defaultWidth: 114,
  fill: "#99B5B7",
  innerFill: "#90EEDA",
  opacity: 0.5
};

export default ConnectBank;
